export const questions = [
	{
		question: "Do you write code?"
	},
	{
		question: "Do you build websites?"
	},
	{
		question: "Are you a chemical that is used to develop photographs?"
	},
	{
		question: "Do you make software?"
	},
	{
		question: "Are you a person or company that builds and sells houses or other buildings on a piece of land?"
	},
	{
		question: "Are you a person who lays out, at full size, the lines of a ship or vessel and prepares templates from them?"
	},
	{
		question: "Do you make apps?"
	},
]


// WEBPACK FOOTER //
// ./src/questions.js